"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
export default function TheNewMavericksSolution() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const services = [{
    id: 1,
    title: "Develop Higher CEO Leadership Consciousness",
    description: "Consciousness is primary for maximum coherent CEO brain functioning to have the right thought to the make right decision.",
    icon: <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_0rolcqv5.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_0rolcqv5.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_0rolcqv5.png-wvc-sizes" alt="Developing Leadership Consciousness" className="w-full h-auto object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105 rounded-lg" loading="lazy" />
  }, {
    id: 2,
    title: "Right Leadership Psychology",
    description: "Correcting the intellect to have right understanding for right decision making that evolves you & your team in the most protected and expansive direction.",
    icon: <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_blummdf8.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_blummdf8.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_blummdf8.png-wvc-sizes" alt="Right Leadership Psychology" className="w-full h-auto object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105 rounded-lg" loading="lazy" />
  }, {
    id: 3,
    title: "Anchor the Outcome",
    description: "Anchor the outcome mentally, emotionally and physically to have maximum support from those in your environment to fulfill it.",
    icon: <img src="https://sincere-skink.10web.cloud/wp-content/uploads/2026/02/image_vbwav3td.jpg" alt="Anchor the Outcome" className="w-full h-auto object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105 rounded-lg" loading="lazy" />
  }];
  return <section id="the-new-mavericks-solution" ref={sectionRef} className="block pt-[50px] pb-[15px] px-[15px] md:py-24 md:px-6 bg-background ![margin:-20px_0px_0px_0px] h-auto md:block">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-display font-bold text-foreground !text-4xl ![margin:-20px_0px_16px_0px] max-md:text-[28px] max-md:leading-[1.2em] max-md:pt-[30px] max-md:mt-[30px]">NEW MAVERICKS CEO SOLUTION</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <Card key={service.id} data-index={i} className={`group border border-border bg-background/80 backdrop-blur-md hover:-translate-y-1 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`}>
              <CardHeader className="@container/card-header @container/card-header @container/card-header @container/card-header @container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 pt-8 ![margin:-50px_0px_0px_0px]">
                <div className="mb-4 flex justify-center">
                  {service.icon}
                </div>
                <CardTitle className="text-2xl text-center relative pb-1">
                  <span className="relative inline-block ![margin:10px_0px_0px_0px]">
                    {service.title}
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full"></span>
                  </span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-center text-white leading-relaxed !text-lg">
                  {service.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}
export function TheNewMavericksSolutionDuplicate() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const services = [{
    id: 1,
    title: "Develop Higher CEO Leadership Consciousness",
    description: "Consciousness is primary for maximum coherent CEO brain functioning to have the right thought to the make right decision.",
    icon: <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_0rolcqv5.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_0rolcqv5.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_0rolcqv5.png-wvc-sizes" alt="Developing Leadership Consciousness" className="w-full h-auto object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105 rounded-lg" loading="lazy" />
  }, {
    id: 2,
    title: "Right Leadership Psychology",
    description: "Correcting the intellect to have right understanding for right decision making that evolves you & your team in the most protected and expansive direction.",
    icon: <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_blummdf8.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_blummdf8.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_blummdf8.png-wvc-sizes" alt="Right Leadership Psychology" className="w-full h-auto object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105 rounded-lg" loading="lazy" />
  }, {
    id: 2,
    title: "Anchor the Outcome",
    description: "Anchor the outcome mentally, emotionally and physically to have maximum support from those in your environment to fulfill it.",
    icon: <img src="https://sincere-skink.10web.cloud/wp-content/uploads/2026/02/image_vbwav3td.jpg" alt="Anchor the Outcome" className="w-full h-auto object-cover transition-transform duration::[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105 rounded-lg" loading="lazy" />
  }];
  return <section id="the-new-mavericks-solution-duplicate" ref={sectionRef} className="py-24 px-6 bg-background !h-[1600px] ![margin:-20px_0px_0px_0px]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-display font-bold text-foreground !text-4xl ![margin:-20px_0px_16px_0px]">NEW MAVERICKS CEO SOLUTION</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <Card key={service.id} data-index={i} className={`group border border-border bg-background/80 backdrop-blur-md hover:-translate-y-1 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`}>
              <CardHeader className="@container/card-header @container/card-header @container/card-header @container/card-header @container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 pt-8 ![margin:-50px_0px_0px_0px]">
                <div className="mb-4 flex justify-center">
                  {service.icon}
                </div>
                <CardTitle className="text-2xl text-center relative pb-1">
                  <span className="relative inline-block ![margin:10px_0px_0px_0px]">
                    {service.title}
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full"></span>
                  </span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-center text-white leading-relaxed !text-xl">
                  {service.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}
export function TheNewMavericksSolutionCopy() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const services = [{
    id: 1,
    title: "Developing Higher CEO Leadership Consciousness",
    description: "Consciousness is primary for maximum coherent CEO brain functioning to have the right thought to the make right decision.",
    icon: <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_0rolcqv5.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_0rolcqv5.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_0rolcqv5.png-wvc-sizes" alt="Developing Leadership Consciousness" className="w-full h-auto object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105 rounded-lg" loading="lazy" />
  }, {
    id: 2,
    title: "Right Leadership Psychology",
    description: "Correcting the intellect to have right understanding for right decision making that evolves you & your team in the most protected and expansive direction.",
    icon: <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_blummdf8.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_blummdf8.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_blummdf8.png-wvc-sizes" alt="Right Leadership Psychology" className="w-full h-auto object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105 rounded-lg" loading="lazy" />
  }, {
    id: 3,
    title: "Anchor the Outcome",
    description: "Anchor the outcome mentally, emotionally and physically to have maximum support from those in your environment to fulfill it.",
    icon: <img src="https://sincere-skink.10web.cloud/wp-content/uploads/2026/02/image_vbwav3td.jpg" alt="Anchor the Outcome" className="w-full h-auto object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105 rounded-lg" loading="lazy" />
  }];
  return <section id="the-new-mavericks-solution-copy" ref={sectionRef} className="py-24 px-6 bg-background !h-[1600px] ![margin:-20px_0px_0px_0px]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-display font-bold text-foreground !text-4xl ![margin:-20px_0px_16px_0px]">NEW MAVERICKS CEO SOLUTION</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <Card key={service.id} data-index={i} className={`group border border-border bg-background/80 backdrop-blur-md hover:-translate-y-1 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`}>
              <CardHeader className="@container/card-header @container/card-header @container/card-header @container/card-header @container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 pt-8 ![margin:-50px_0px_0px_0px]">
                <div className="mb-4 flex justify-center">
                  {service.icon}
                </div>
                <CardTitle className="text-2xl text-center relative pb-1">
                  <span className="relative inline-block ![margin:10px_0px_0px_0px]">
                    {service.title}
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full"></span>
                  </span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-center text-white leading-relaxed !text-xl">
                  {service.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}